import React from 'react';
import {
  ImageBackground, Pressable, StyleSheet, View, Text,
} from 'react-native';
import PropTypes from 'prop-types';
import APMStyles from '../styles';

function APMCard(props) {
  const { backgroundImg, title, onPress } = props;

  return (
    <Pressable style={styles.container} onPress={onPress}>
      <ImageBackground source={backgroundImg} style={styles.backgroundImage}>
        <View style={styles.banner}>
          <Text style={styles.title}>{title.toUpperCase()}</Text>
        </View>
      </ImageBackground>
    </Pressable>
  );
}

APMCard.defaultProps = {
  backgroundImg: undefined,
  title: '',
  onPress: () => {},
};

APMCard.propTypes = {
  backgroundImg: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  onPress: PropTypes.func,
};

const styles = StyleSheet.create({
  backgroundImage: {
    height: 280,
  },
  banner: {
    backgroundColor: APMStyles.colors.background,
    alignSelf: 'flex-start',
    borderBottomRightRadius: 20,
  },
  title: {
    marginTop: 0,
    padding: 10,
    paddingRight: 20,
    fontSize: APMStyles.typography.title,
    color: APMStyles.colors.text,
  },
});

export default APMCard;
